import React from "react";
import CouponCampaign from "../coupons-shared/coupon-campaign";
import { useHistory } from "react-router-dom";

const CouponCampaignList = ({ campaigns }) => {
  let history = useHistory();

  const routeToCoupon = (campaignId) => {
    return (e) => {
      e.preventDefault();
      history.push(`/coupon/${campaignId}`);
    };
  };

  return campaigns.map((campaign) => {
    let available = 0;
    campaign.couponCodes.map((couponCode) => {
      if (couponCode.couponState === "1") {
        available = 1;
      }
      return available;
    });

    return (
      <CouponCampaign
        key={campaign.id}
        campaign={campaign}
        onClick={routeToCoupon(campaign.id)}
      />
    );
  });
};
export default CouponCampaignList;
